import React, { FC, useState, useEffect, useRef } from 'react';
import { Header } from 'modules/paywall/components/header';
import { PlanDescription } from 'modules/paywall/components/planDescription';
import { Price } from 'modules/paywall/components/price';
import { Modal } from 'modules/paywall/components/modal';
import { Guarantee } from 'modules/paywall/components/guarantee';
import { Reviews } from 'modules/paywall/components/reviews';
import { GENDER } from '../../../../../activationInstructions/components/paymentSuccessfulV1/params';
import { appStore } from '@store';
import { sendAnalyticsEvents, sendAnalyticsEventsSelectSubscription } from './helpers';
import * as S from './styled';

interface Props {
	children: React.ReactElement;
	gender?: GENDER;
}

export const NewPaywallLayoutAcademy: FC<Props> = props => {
	const { eventsTracker } = appStore;
	const { product } = appStore.paymentStore;

	const { children } = props;
	const [showModal, setShowModal] = useState(false);
	const ref = useRef<HTMLDivElement>(null);
	const root = document.getElementById('root');
	const versionModal = 'V1';

	let eventCheck = true;
	function handleScroll() {
		if (eventCheck) {
			if (ref.current && ref.current?.getBoundingClientRect().y < -170) {
				setShowModal(true);
				sendAnalyticsEvents(eventsTracker, versionModal);
				if (root) {
					root.style.overflowY = 'hidden';
				}
				eventCheck = false;
			}
		}
	}

	function hiddeModal() {
		if (root) {
			if (product.name) {
				sendAnalyticsEventsSelectSubscription(eventsTracker, product.name);
			}
			root.style.overflowY = 'scroll';
		}
		setShowModal(false);
	}

	useEffect(() => {
		root?.addEventListener('scroll', handleScroll);

		return () => {
			root?.removeEventListener('scroll', handleScroll);
		};
	}, []);

	return (
		<S.Container>
			<Header />
			<div ref={ref}></div>
			<S.PlanDescriptionCont>
				<PlanDescription />
			</S.PlanDescriptionCont>
			<Price />
			<Guarantee />
			<Reviews />
			<Modal showModal={showModal} onClick={hiddeModal}>
				{children}
			</Modal>
		</S.Container>
	);
};
